'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

define(['app', 'elementViewed'], function (app, elementViewed) {

  var subscriptionComponent = function subscriptionComponent() {
    var component = {};

    var _config = {
      radioSelector: '[data-radio]',
      tabLinks: '[data-js-element=subscriptionComponent_tab-link]',
      tabPanels: '[data-js-element=subscriptionComponent_tab-panel]',
      tabLinkActive: 'subscriptionComponent_tabTitle-active',
      tabPanelActive: 'subscriptionComponent_tabPanel-active',

      subscribeChannels: {
        subscriptionTerm: 'subscriptionComponent/subscriptionTerm',
        subscriptionType: 'subscriptionComponent/subscriptionType'
      }
    };

    var _init = function _init(element) {
      component.element = element;
      component.bind();
      component.onLoadShowRequiredPanel();
      return component;
    };

    var _bind = function _bind() {
      var tabLinks = component.element.querySelectorAll(component.config.tabLinks);
      component.attachEvent(tabLinks);
    };

    var _onLoadShowRequiredPanel = function _onLoadShowRequiredPanel() {
      var radioButtons = component.element.querySelectorAll(component.config.radioSelector);
      [].concat(_toConsumableArray(radioButtons)).forEach(function (radio) {
        if (radio.checked) {
          var subscriptionType = radio.getAttribute('data-card-subscription-type');
          var termOption = radio.getAttribute('data-card-subscription-term');
          app.publish(component.config.subscribeChannels.subscriptionTerm, termOption, true);
          app.publish(component.config.subscribeChannels.subscriptionType, subscriptionType, true);
          var selectedTabIndex = subscriptionType == 'recurring' ? 1 : 0;
          component.tabLinkClicked(selectedTabIndex);
        }
      });
    };

    var _attachEvent = function _attachEvent(tabLinks) {
      var _loop = function _loop(i) {
        tabLinks[i].addEventListener('click', function () {
          component.tabLinkClicked(i);
        });
      };

      for (var i = 0; i < tabLinks.length; i++) {
        _loop(i);
      }
    };

    var _tabLinkClicked = function _tabLinkClicked(i) {
      component.removeActiveClass();
      component.showActiveTab(i);
    };

    var _removeActiveClass = function _removeActiveClass() {
      var tabLinks = component.element.querySelectorAll(component.config.tabLinks);
      var tabPanels = component.element.querySelectorAll(component.config.tabPanels);
      [].concat(_toConsumableArray(tabLinks)).forEach(function (element) {
        app.element.removeClass(component.config.tabLinkActive, element);
      });
      [].concat(_toConsumableArray(tabPanels)).forEach(function (element) {
        app.element.removeClass(component.config.tabPanelActive, element);
      });
    };

    var _showActiveTab = function _showActiveTab(i) {
      var selectedTabLink = component.element.querySelectorAll(component.config.tabLinks)[i];
      var selectedTabPanel = component.element.querySelectorAll(component.config.tabPanels)[i];
      app.element.addClass(component.config.tabLinkActive, selectedTabLink);
      app.element.addClass(component.config.tabPanelActive, selectedTabPanel);
    };

    component.config = _config;
    component.init = _init;
    component.bind = _bind;
    component.attachEvent = _attachEvent;
    component.tabLinkClicked = _tabLinkClicked;
    component.showActiveTab = _showActiveTab;
    component.removeActiveClass = _removeActiveClass;
    component.onLoadShowRequiredPanel = _onLoadShowRequiredPanel;

    return component;
  };

  return subscriptionComponent;
});
//# sourceMappingURL=subscriptionComponent.js.map
